import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from '@app/shared/shared.module';
import { NotFoundComponent } from './shared/pages';

const appRoutes: Routes = [
	{
		path: '',
		loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
	},
	{
		path: '**',
		component: NotFoundComponent,
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(appRoutes, {
			useHash: false,
			initialNavigation: 'enabledNonBlocking',
			// anchorScrolling: 'enabled',
			// scrollPositionRestoration: 'top',
			// enableTracing: true
		}),

		SharedModule,
	],
	exports: [RouterModule],
	providers: [],
})
export class AppRoutingModule {}
